var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCircledCheckmarkFull = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 26,
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)",
  strokeWidth: 2,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#46CC88",
  fill: "#46CC88",
  fillRule: "nonzero",
  cx: 11.711,
  cy: 11.711,
  r: 11.711
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "m5.73 11.337 4.486 4.487 7.85-7.851"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCircledCheckmarkFull);
export default ForwardRef;